import { validHexaColorReg } from "@/components/color-swatch/color-swatch";
import { z } from "zod";

const colorCheckSchema = z.string().trim().regex(validHexaColorReg).optional();

const ChatbotWidgetDesignSettingsSchema = z.object({
  headerStartColor: colorCheckSchema,
  headerEndColor: colorCheckSchema,
  titleColor: colorCheckSchema,
  chatBackgroundColor: colorCheckSchema,
  chatFontColor: colorCheckSchema,
  sendButtonBackgroundColor: colorCheckSchema,
  sendButtonFontColor: colorCheckSchema,
  chatButtonBgColor: colorCheckSchema,
  borderColor: colorCheckSchema,
  "chat-toggle-button--background-color": colorCheckSchema,
  "chat-toggle-button--color": colorCheckSchema,
  banner: z.object({
    enabled: z.boolean(),
    imageUrl: z.string(),
    imageId: z.string().optional(),
    text: z.string(),
  }),
});

export const BaseWidgetSchema = z.object({
  name: z.string().trim(),
  logo_url: z.string().trim(),
  logo_id: z.string().trim(),
  greeting: z.string().trim().nonempty(),
  site_url: z.string().trim(),
  brand_color: z.string().trim(),
});

export const ChatbotWidgetSchema = BaseWidgetSchema.extend({
  designSettings: ChatbotWidgetDesignSettingsSchema,
});
